import ContactsBanner from './images/ContactsBanner.jpg';
import Ship from './images/ship.jpeg';
import BackgroundVideo from './videos/background.mp4';
import './App.css';
import { AppleOutlined, GoogleOutlined, FacebookOutlined } from '@ant-design/icons';
import { Col, Row, Button, Typography, Flex, Input, Divider } from 'antd';
import {NavLink} from "react-router-dom";

const { Title, Text } = Typography;

function Login() {
  return (
    <>
      <Row>
        <Col span={24} style={{padding: '0 32px'}}>
          <NavLink to={'/'}>
            <h4>Stork<span style={{fontWeight: '400'}}>Stay</span></h4>
          </NavLink>
        </Col>
      </Row>
    
      <Row
          style={{
                  maxWidth: 1024,
                  margin: '64px auto 128px auto'
                }}
            >
                <Col
                    span={12}
                    style={{ textAlign: "left", paddingRight: 48 }}
                    className={'cloud'}
                >
                    <Title level={1} style={{ marginBottom: 32, marginTop: 220 }}>Welcome back</Title>
                    <Title level={4} style={{fontWeight: "normal" }}>Please provide details associated with your <strong>Stork</strong>Stay account</Title>
                </Col>

                <Col span={12}>
                    <Flex vertical gap="large" style={{maxWidth: '80%', marginBottom: 32}}>
                      <Title level={3} style={{ marginBottom: 32}}>Login</Title>
                      <Text type='secondary'>Please provide details associated with your account</Text>
                        <Input size='large' placeholder="Username / Email address" variant="filled" />
                        <Input type='password' size='large' placeholder="Password" variant="filled" />
                        <Button type="primary" color="default" size='large' variant="solid" htmlType="submit" style={{width: '100%'}}>
                          Submit
                        </Button>
                        <Divider>or continue with</Divider>

                        <div style={{margin: '0 auto'}}>
                        <AppleOutlined style={{fontSize: 16}} />
                        <GoogleOutlined style={{margin: '0 16px'}} />
                        <FacebookOutlined />
                        </div>

                        <small style={{display: 'block', margin: '0 auto'}}>Don’t have an account?</small>
                        
                        <Button color="default" variant="filled" size='large' htmlType="submit" style={{width: '100%'}}>Register</Button>
      
                     </Flex>
                </Col>
            </Row>
    </>
  );
}

export default Login;